module.exports = __webpack_public_path__ + "static/media/2-9.78e6429a.svg";